
import 'slick-carousel'
import $ from 'jquery'

class SlickInit {
    constructor (theme, elem) {
        this._elem = elem
        this._slider = null
    }

    onInit () {
        if (this._elem.getAttribute('data-product-image-slider') === null) {
            this._slider = $(this._elem).slick()
        }
    }
}

export default SlickInit



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SlickInit.js